import React, { useMemo } from 'react';
import './button.css';

const Button = ({
    shape='rect', // (string) 'rect', 'square'. This could be improved later with dynamic sizes like the banner
    styleType='default', // (string) 'default', 'warning'
    tileSize='sm', // (string) 'sm', 'md', 'lg'. How big the button should be
    disabled=false,
    children,
    ...rest
}) => {
    return (
        <button 
            className={`btn btn-${shape} btn-${tileSize} btn-${shape}-${styleType}`}
            {...rest}
        >
            {children}
        </button>
    )
}

export default Button;